export const addLocation = (location: []) => {
    console.log('actions-location', location)

    return {
        type: 'CREATE',
        playground: location
    }
}
